import {
    oilCardList
} from "@/api/fee";
import store from '@/utils/store';

const actions = {
    // 获取油卡列表
    oilCardList(context, isReLoad = false) {
        store.loadCacheData(context, 'oilCardList', oilCardList, null, {
            isReLoad: isReLoad
        });
    }
}
export default actions